import { useEffect } from 'react';
import { MoreHorizontal } from 'react-feather';
import useComponentVisible from '../../hooks/useComponentVisible';
var MoreDropDown = function (_a) {
    var children = _a.children;
    var _b = useComponentVisible(true), ref = _b.ref, isComponentVisible = _b.isComponentVisible, setIsComponentVisible = _b.setIsComponentVisible;
    useEffect(function () {
        setIsComponentVisible(false);
    }, []);
    return (<div ref={ref} className="flex items-center">
      <button className="relative" onClick={function () { return setIsComponentVisible(!isComponentVisible); }}>
        <MoreHorizontal size={24}/>
      </button>
      {isComponentVisible &&
            <div className="p-4 rounded-lg bg-white shadow flex flex-col gap-6 absolute -right-0 top-full">
          {children}
        </div>}

    </div>);
};
export default MoreDropDown;
